import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { ResourceSpecialCausesReviewView } from "src/components/views/spc/processImprovement/ResourceSpecialCausesReviewView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/spc/specialCauses/resources")({
	staticData: { title: i18n.t("resource_special_causes"), legacyViewKey: "resourceSpecialCausesReviewView" },
	component: RouteComponent,
});

function RouteComponent() {
	return <ResourceSpecialCausesReviewView />;
}
